import React, { useContext, useState } from 'react';

import classnames from 'classnames';
import {
  string, bool, element, node, oneOfType, arrayOf
} from 'prop-types';

import './MenuBar.scss';
import { CSSTransition } from 'react-transition-group';
import { ExperienceContext } from '@thd-nucleus/experience-context';

const MenuBarItem = ({ title, link, active, label }) => {

  const { channel } = useContext(ExperienceContext);

  const itemViewMode = () => {
    return channel === 'mobile' ? 'menu-bar__item-mobile' : 'menu-bar__item';
  };

  const [isHovered, setIsHovered] = useState(false);

  const onHover = () => {
    setIsHovered(!isHovered);
  };

  return (
    <li className={itemViewMode()} onMouseEnter={onHover} onMouseLeave={onHover}>
      <CSSTransition in={isHovered && !active} timeout={300} classNames="menu-bar__link">
        <a
          className={classnames('menu-bar__link', { 'menu-bar__link--force-open': active })}
          href={link}
          aria-label={label}
        >{title}
        </a>
      </CSSTransition>
    </li>
  );
};

const MenuBar = ({ classNames, children }) => {

  const wrapperClassNames = classnames('menu-bar', classNames);

  return (
    <ul className={wrapperClassNames}>
      {children}
    </ul>
  );
};

MenuBar.displayName = 'MenuBar';

MenuBarItem.displayName = 'MenuBarItem';

MenuBarItem.propTypes = {
  title: string.isRequired,
  link: string.isRequired,
  active: bool,
  label: string,
};

MenuBarItem.defaultProps = {
  active: false,
  label: null
};

MenuBar.propTypes = {
  classNames: string,
  children: oneOfType([arrayOf(node), node]).isRequired,
};

MenuBar.defaultProps = {
  classNames: ''
};

export { MenuBar, MenuBarItem };
